export const IMAGE_TYPE = {
  SMALL: "small",
  "16_9": "16_9",
  DEFAULT: "default",
  FULL: "full",
};
export const SHADOW_TYPE = {
  NONE: "none",
  FULL: "full",
  GRADIENT: "gradient",
};
